var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GeographyMasthead'),_vm._v(" "),(_vm.ready)?_c('section',[_c('assignment-list',{attrs:{"assignments":_vm.assignments}},[_c('div',{staticClass:"empty",attrs:{"slot":"empty"},slot:"empty"},[_c('h2',[_vm._v("There are currently no assignments due.")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05833932","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routes/Assignments/index.vue
// module id = null
// module chunks = 